import { Inject, Injectable, Injector } from '@angular/core';
import { MsalBroadcastService, MsalGuardConfiguration, MsalService, MSAL_GUARD_CONFIG } from '@azure/msal-angular';
import { BehaviorSubject } from 'rxjs';
import { DataService } from 'src/app/services/data.service';
import { filter } from 'rxjs/operators';
import { AuthenticationResult, AccountInfo, EventMessage, EventType, InteractionStatus, InteractionType, PopupRequest, RedirectRequest } from '@azure/msal-browser';
import { UserProfileService } from '../http/user-profile.service';

@Injectable({
  providedIn: "root",
})
export class AuthenticationService {
  loggedInUser: BehaviorSubject<AccountInfo>;
  private loggedIn = false;

  msalBroadcastComplete$ = this.msalBroadcastService.inProgress$
    .pipe(
      filter((status: InteractionStatus) => status === InteractionStatus.None)
    )

  msalLoginSuccess$ = this.msalBroadcastService.msalSubject$
    .pipe(
      filter((msg: EventMessage) => {
       // console.log(msg);
        return msg.eventType === EventType.LOGIN_SUCCESS}),
    )


  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private msalBroadcastService: MsalBroadcastService,
    private injector: Injector,
    private ds: DataService,
    private authService: MsalService,
    ) { }
  
  // insight implementation - comment if not needed
   login() {
    if (this.msalGuardConfig.interactionType === InteractionType.Redirect) {
      this.loginPopup();
    } else {
      this.loginRedirect();
      //this.authService.instance.handleRedirectPromise();
    }
  }

   loginRedirect() {
    if (this.msalGuardConfig.authRequest) {
      this.authService.loginRedirect({ ...this.msalGuardConfig.authRequest } as RedirectRequest);
    } else {
      this.authService.loginRedirect();
      // this.authService.instance.handleRedirectPromise();
    }

  }

  loginPopup() {
    if (this.msalGuardConfig.authRequest) {
      this.authService.loginPopup({ ...this.msalGuardConfig.authRequest } as PopupRequest)
        .subscribe((response: AuthenticationResult) => {
          this.loggedInUser = new BehaviorSubject<AccountInfo>(response.account)
          //console.log(this.loggedInUser)
          this.authService.instance.setActiveAccount(response.account);
        });
    } else {
      this.authService.loginPopup()
        .subscribe((response: AuthenticationResult) => {
          this.loggedInUser = new BehaviorSubject<AccountInfo>(response.account)
          this.authService.instance.setActiveAccount(response.account);
        });
    }
  }

  logOut(popup?: boolean) {
    this.injector.get(UserProfileService).logout();

    if (popup) {
      this.authService.logoutPopup({
        mainWindowRedirectUri: "/"
      });
    } else {
      this.authService.logoutRedirect();
    }

  }

  setLoginDisplay() {
    this.loggedIn = this.authService.instance.getAllAccounts().length > 0;
  }

  checkAndSetActiveAccount(): void {
    /**
     * If no active account set but there are accounts signed in, sets first account to active account
     * To use active account set here, subscribe to inProgress$ first in your component
     * Note: Basic usage demonstrated. Your app may require more complicated account selection logic
     */
    let activeAccount = this.authService.instance.getActiveAccount();
    if (activeAccount && this.injector.get(UserProfileService).currentUserValue === null) {
      this.injector.get(UserProfileService).getLoggedinUserDetails();
    }

    if (!activeAccount && this.authService.instance.getAllAccounts().length > 0) {
      let accounts = this.authService.instance.getAllAccounts();
      this.authService.instance.setActiveAccount(accounts[0]);
    }
  }

  /**
 * Broadcast login success
 */
  broadcast() {
    this.setLoginDisplay();
    this.msalBroadcastComplete$
      .subscribe(() => {
        this.setLoginDisplay();
        this.checkAndSetActiveAccount();
      });
  }

  getADUserProfile() {
    return this.authService.instance.getAllAccounts()[0];
  }

  /**
   * Get user name
   * @return user name string upon successful login
   */
  getUserName(): string {
    return this.authService.instance.getAllAccounts()[0]?.name;
  }

  /**
   * Get user id.
   * * @return user id upon successful login.
   */
  getUserID() {
    return this.authService.instance.getAllAccounts()[0].localAccountId;
  }

  ngOnDestroy() { }

  isLoggedIn(): boolean {
    return this.loggedIn;
  }

}
